module.exports = __webpack_public_path__ + "static/media/oyo.a4fcb39c.svg";